import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const Customization = React.lazy(() => import("../../containers/Buy/Customization/CustomizationContainer"));
const PaymentStepper = React.lazy(() => import("../../containers/Buy/PaymentStepperContainer"));
const EntryPoint = React.lazy(() => import("../../containers/Buy/EntryPointContainer"));

const buySubRoutes: RouteObject[] = [
    {
        title: "Customization",
        path: "customization/*",
        component: <Customization />
    },
    {
        title: "Payment Stepper",
        path: "paymentStepper/*",
        component: <PaymentStepper />
    },
]

export const buyRoutes: RouteObject[] = [
    {
        title: "Buy",
        path: "/buy",
        component: <EntryPoint />,
        subRoutes: buySubRoutes
    }
];